// extracted by mini-css-extract-plugin
export default {"headerText":"header_headerText__iFKOF","title":"header_title__hT60b","navRow":"header_navRow__joZJy"};